import { createContext, useContext } from 'react';
import CommentStore from './commentStore';
import ActivityStore from './activityStore';
import CommonStore from './commonStore';
import ModalStore from './modalStore';
import UserStore from './userStore';
import SidebarStore from './sidebarStore';
import ReceivingDeliveryStore from './receivingdeliverystore';
import MediaAssetStore from './mediaAssetStore';
import ProfileStore from './ProfileStore';
import VaultStore from './vaultStore';
import DepartmentStore from './departmentStore';
import CustomerStore from './customerStore';
import DeviceStore from './deviceStore';
import ShelfRackStore from './shelfRackStore';
import WorkLevelStore from './worklevelStore';
import OrderStore from './orderStore';
import DeliveryStore from './deliveryStore';
import TemplateStore from './templateStore';
import ElementStore from './elementStore';
import DashboardStore from './dashboardStore';
import WorkflowConfigurationStore from './workflowConfigurationStore';
import CommunicationStore from './communicationStore';
import EmailStore from './emailStore';
import RolesAndPermissionsStore from './rolesAndPermissionsStore';
import RolesAndPermissionsIDStore from './rolesAndPermissionsIDStore';
import RejectionStoreTest from './rejectionStore';
import clonedStore from './clonedStore';
import MetaDataStore from './metaDataStore';
import ApiStore from './apiStore';
import ReportStore from './reportStore';
import PivotStore from '../../features/PivotReports/PivotStore';
import KanbanStore from './KanbanStore';
import QuickScanStore from './QuickScanStore';
import RestorationStore from '../../features/Restoration/RestorationStore';
import DashboardConfigurationStore from './dashboardConfiguration';
import DynamicDashboardStore from './dynamicDashboard';
import DynamicDashboard from './dynamicDashboard';
import RolesPermissions from './rolesAndPermission';
import TrackingReportStore from '../../features/SmartTracker/TrackingReportStore';
import FilmAnaysisAndRepairReportStore from '.././stores/FilmAnaysisAndRepairReport/index';
import ADLtrackingStore from '../../features/ADL/adlTrackingStore';
import ViewStore from './viewStore';
import CommunicationSettingStore from './CommunicationSettingForDynamicDashboard';
import EmailMessageStore from './emailMessage';
import CRMStore from './CRMStore';
import NFAI_Restoration_SmartflowsStore from './NFAI_Restoration_Smartflow';
import masteringStore from '../../features/MediaAssets/NFAI_Report/Master Reports/service';

interface Store {
  activityStore: ActivityStore;
  commonStore: CommonStore;
  userStore: UserStore;
  modalStore: ModalStore;
  sidebarStore: SidebarStore;
  dashboardStore: DashboardStore;
  receivingdeliveryStore: ReceivingDeliveryStore;
  mediaAssetStore: MediaAssetStore;
  profileStore: ProfileStore;
  commentStore: CommentStore;
  vaultStore: VaultStore;
  departmentStore: DepartmentStore;
  customerStore: CustomerStore;
  WorkLevelStore: WorkLevelStore;
  DeviceStore: DeviceStore;
  ShelfRackStore: ShelfRackStore;
  OrderStore: OrderStore;
  TemplateStore: TemplateStore;
  DeliveryStore: DeliveryStore;
  ElementStore: ElementStore;
  workflowConfigurationStore: WorkflowConfigurationStore;
  CommunicationStore: CommunicationStore;
  ApiStore: ApiStore;
  emailStore: EmailStore;
  RolesAndPermissionsStore: RolesAndPermissionsStore;
  RolesAndPermissionsIDStore: RolesAndPermissionsIDStore;
  rejectionStore: RejectionStoreTest;
  clonedStore: clonedStore;
  metaDataStore: MetaDataStore;
  reportStore: ReportStore;
  PivotStore: PivotStore;
  KanbanStore: KanbanStore;
  QuickScanStore: QuickScanStore;
  RestorationStore: RestorationStore;
  DashboardConfigurationStore: DashboardConfigurationStore;
  DynamicDashboardStore: DynamicDashboardStore;
  RolesPermissionsStore: RolesPermissions;
  TrackingReportStore: TrackingReportStore;
  FilmAnaysisAndRepairReportStore: FilmAnaysisAndRepairReportStore;
  ADLtrackingStore: ADLtrackingStore;
  viewStore: ViewStore;
  CommunicationSettingStore: CommunicationSettingStore;
  EmailMessageStore:EmailMessageStore;
  CRMStore:CRMStore;
  NFAI_Restoration_SmartflowsStore:NFAI_Restoration_SmartflowsStore;
  masteringStore: masteringStore;
}

export const store: Store = {
  activityStore: new ActivityStore(),
  commonStore: new CommonStore(),
  userStore: new UserStore(),
  modalStore: new ModalStore(),
  sidebarStore: new SidebarStore(),
  dashboardStore: new DashboardStore(),
  receivingdeliveryStore: new ReceivingDeliveryStore(),
  mediaAssetStore: new MediaAssetStore(),
  profileStore: new ProfileStore(),
  commentStore: new CommentStore(),
  vaultStore: new VaultStore(),
  departmentStore: new DepartmentStore(),
  customerStore: new CustomerStore(),
  WorkLevelStore: new WorkLevelStore(),
  DeviceStore: new DeviceStore(),
  ShelfRackStore: new ShelfRackStore(),
  OrderStore: new OrderStore(),
  DeliveryStore: new DeliveryStore(),
  TemplateStore: new TemplateStore(),
  ElementStore: new ElementStore(),
  workflowConfigurationStore: new WorkflowConfigurationStore(),
  CommunicationStore: new CommunicationStore(),
  ApiStore: new ApiStore(),
  emailStore: new EmailStore(),
  RolesAndPermissionsStore: new RolesAndPermissionsStore(),
  RolesAndPermissionsIDStore: new RolesAndPermissionsIDStore(),
  rejectionStore: new RejectionStoreTest(),
  clonedStore: new clonedStore(),
  metaDataStore: new MetaDataStore(),
  reportStore: new ReportStore(),
  PivotStore: new PivotStore(),
  KanbanStore: new KanbanStore(),
  QuickScanStore: new QuickScanStore(),
  RestorationStore: new RestorationStore(),
  DashboardConfigurationStore: new DashboardConfigurationStore(),
  DynamicDashboardStore: new DynamicDashboard(),
  RolesPermissionsStore: new RolesPermissions(),
  TrackingReportStore: new TrackingReportStore(),
  FilmAnaysisAndRepairReportStore: new FilmAnaysisAndRepairReportStore(),
  ADLtrackingStore: new ADLtrackingStore(),
  viewStore: new ViewStore(),
  CommunicationSettingStore: new CommunicationSettingStore(),
  EmailMessageStore: new EmailMessageStore(),
  CRMStore: new CRMStore(),
  NFAI_Restoration_SmartflowsStore: new NFAI_Restoration_SmartflowsStore(),
  masteringStore: new masteringStore(),
};

export const StoreContext = createContext(store);

export function useStore() {
  return useContext(StoreContext);
}
